module.exports = __webpack_public_path__ + "img/message-notification-circle.a1808a6f.svg";